export enum ODataFieldType {
  Primitive = 'Primitive',
  ArrayPrimitive = 'ArrayPrimitive',
  Array = 'Array',
}

export interface ODataField {
  name: string;
  root?: string;
  type: ODataFieldType;
}
